module.exports = __webpack_public_path__ + "assets/2d6db1db1cbfe6b9c136deeb0fbd9def.png";